const STORAGE_KEY = 'maapp_cookie_consent_v1';

export const COOKIE_CONSENT_VERSION = 1;

export function getCookieConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.version !== COOKIE_CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function hasCookieConsent() {
  return Boolean(getCookieConsent()?.essential);
}

export function saveCookieConsent({ analytics = false } = {}) {
  const record = {
    version: COOKIE_CONSENT_VERSION,
    essential: true,
    analytics: Boolean(analytics),
    recordedAt: new Date().toISOString(),
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch {
    /* ignore */
  }
  return record;
}
